import React, { useState } from "react";
import { UiMenu } from "../_uiComponents/Dashboard/UiMenu";
import { ProfileIocn } from "../../styles/img/svg/ProfileIocn";
import PinnacleLogo from "../../styles/img/pinnacleLogo.png";
import { useNavigate } from "react-router-dom";
import { CloseIcon } from "../../styles/img/svg/CloseIcon";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { TRANSLATION_CONST } from "../../_redux/_constants";

export const UiMobileSideMenu = (props) => {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const commonData = useSelector((state) => state?.commonData);

  const faqNav = () => {
    props?.closeMobileMenu();
  };

  const termsNav = () => {
    props?.closeMobileMenu();
  };

  const truncateText = (text, maxLength = 15) =>
    text?.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  return (
    <div className="dashboard df-mobile-sidebar">
      {props.openMenu && (
        <div
          className="df-db-mob-menu-overlay"
          onClick={props.closeMobileMenu}
        ></div>
      )}

      {/* Sidebar */}
      <div className={`sidebar ${props.openMenu ? "open" : ""}`}>
        <div className="sidebar__close-icon" onClick={props.closeMobileMenu}>
          <CloseIcon />
        </div>
        <div onClick={props.goToProfile} className="df-mobile-sidebar__profile">
          {commonData?.profilePicturePath ? (
            <img
              src={commonData?.profilePicturePath}
              alt="Profile"
              className="df-mobile-sidebar__profile-picture"
            />
          ) : (
            <ProfileIocn className="df-mobile-sidebar__profile-picture" />
          )}
          <div>
            <h2>
              {t("Hi")} {truncateText(commonData?.nickName, 15)}!
            </h2>
            <img src={props?.selectedLogo} />
          </div>
        </div>
        <UiMenu handleToggle={props?.closeMobileMenu} />
      </div>
    </div>
  );
};
